import { useEffect, useState } from "react";

let deferredPrompt = null;
const subs = new Set();
const notify = () => subs.forEach((cb) => cb());

export function isIOS() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  const iOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
  const isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(ua);
  return iOS && isSafari;
}

export function isStandalone() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia?.("(display-mode: standalone)")?.matches ||
    window.navigator.standalone === true
  );
}

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    notify();
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    notify();
  });
}

export function getInstallState() {
  return {
    hasNativePrompt: !!deferredPrompt,
    isIOS: isIOS(),
    isStandalone: isStandalone(),
    canInstall: (!!deferredPrompt || isIOS()) && !isStandalone(),
  };
}

export async function promptInstall() {
  if (!deferredPrompt) return "unavailable";
  deferredPrompt.prompt();
  let outcome = "dismissed";
  try {
    const choice = await deferredPrompt.userChoice;
    outcome = choice?.outcome || "dismissed";
  } catch {}
  deferredPrompt = null;
  notify();
  return outcome;
}

export function useInstall() {
  const [state, setState] = useState(getInstallState());
  useEffect(() => {
    const cb = () => setState(getInstallState());
    subs.add(cb);
    return () => subs.delete(cb);
  }, []);
  return { ...state, promptInstall };
}
